import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
import { colors, typography, size } from "../../../shared/constants";
var ListEmpty = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 18px;\n  margin: ", "px 0;\n  line-height: 1.78;\n  text-align: center;\n  color: ", ";\n  font-weight: ", ";\n"])), size.xl3, colors.gray4, typography.weight.book);
export { ListEmpty };